var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDriverPreferencesFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dvg0yphhta",
    d: "M45.09 56.692c0 6.969 11.273 14.061 11.273 14.061s11.274-7.09 11.274-14.061V32.77H45.09v23.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8ph0rcfggb",
    d: "M5.854 43.073V30.558l-2.59-1.85c-1.578-1.126-3.483.537-3.243 2.83l.592 5.657c.35 3.365 2.591 5.878 5.241 5.878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7t92zv8xbc",
    d: "M40.738 43.073V30.558l2.59-1.85c1.577-1.126 3.482.537 3.242 2.83l-.59 5.657c-.353 3.365-2.593 5.878-5.242 5.878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "gbetxoh7hd",
    d: "M4.228 18.046c-.336-.107-.692.078-.796.413-.106.333.078.689.411.794l8.956 2.844c.185-.23.357-.468.51-.726.073-.123.14-.252.214-.375l-9.295-2.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "duo5y49k8e",
    d: "M6.44 13.522c-.331-.119-.693.052-.81.382-.119.33.052.693.382.81l9.171 3.289c.199-.378.402-.753.594-1.134L6.44 13.522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fpkmlx1z1f",
    d: "M8.226 8.633c-.323-.132-.695.024-.826.348-.133.322.023.693.347.825l9.54 3.885c.172-.385.344-.77.511-1.159L8.226 8.633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "5opf1xrtzg",
    d: "M14.14 18.046c.335-.107.69.078.795.413.105.333-.08.689-.413.794l-8.954 2.844c-.185-.23-.357-.468-.511-.726-.073-.123-.14-.252-.214-.375l9.296-2.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e3r20tdlmh",
    d: "M11.927 13.522c.33-.119.692.052.81.382.118.33-.054.693-.382.81l-9.171 3.289c-.199-.378-.403-.753-.596-1.134l9.339-3.347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t0ea4jjvdi",
    d: "M10.141 8.633c.322-.132.694.024.825.348.132.322-.024.693-.347.825L1.08 13.69c-.174-.385-.345-.77-.513-1.159l9.574-3.899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u58jf39lvj",
    d: "M54.987.519C65.22.524 75.429 11.036 75.374 18.434v8.895c.45.405.698.969.718 1.547 1.174.123 2.179 1.478 2 3.18l-.59 5.658c-.282 2.69-1.77 4.836-3.71 5.588-1.455 4.391-4.12 8.033-7.7 10.932l-.001 1.882 25.86 5.044c2.703.527 5.202 1.804 7.212 3.68l.298.286c2.053 2.028 3.425 4.644 3.924 7.486l6.07 34.539c.988 5.624-2.186 11.15-7.542 13.13l-16.04 5.93-62.233-.028-15.926-5.899C2.364 118.302-.808 112.78.18 107.16l6.067-34.563c.498-2.84 1.87-5.452 3.922-7.475 2.058-2.03 4.669-3.406 7.505-3.96l25.871-5.045v-1.882c-3.579-2.9-6.244-6.54-7.7-10.932-1.94-.752-3.428-2.897-3.709-5.588l-.592-5.657c-.178-1.703.827-3.058 2.002-3.182.021-.648.33-1.277.888-1.687l.001-7.342-.022-2.159.067-.051C35.216 10.29 45.113.516 54.987.519z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0H200V200H0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#40AE29",
    d: "M25.186 126.183l62.233.028 16.04-5.93c5.355-1.98 8.53-7.506 7.541-13.13l-6.07-34.539c-.499-2.842-1.87-5.458-3.924-7.486-2.058-2.033-4.67-3.413-7.51-3.966l-37.133-7.243-37.144 7.245c-2.837.553-5.447 1.93-7.505 3.959-2.053 2.023-3.424 4.636-3.923 7.475l-6.066 34.563c-.987 5.62 2.184 11.143 7.535 13.125l15.926 5.9z",
    transform: "translate(44.000000, 35.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F0C58A",
    xlinkHref: "#dvg0yphhta"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillOpacity: 0.08,
    xlinkHref: "#dvg0yphhta"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.000000, 35.000000) translate(33.067966, 0.518818)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F0C58A",
    xlinkHref: "#8ph0rcfggb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillOpacity: 0.08,
    xlinkHref: "#8ph0rcfggb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.000000, 35.000000) translate(33.067966, 0.518818)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F0C58A",
    xlinkHref: "#7t92zv8xbc"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillOpacity: 0.08,
    xlinkHref: "#7t92zv8xbc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F0C58A",
    d: "M27.57 57.972c9.674-4.384 15.953-12.126 15.953-23.312v-10.4c0-11.885-9.056-21.52-20.228-21.52-11.17 0-20.227 9.635-20.227 21.52v10.4c0 11.186 6.28 18.928 15.953 23.312 2.73 1.238 5.818 1.238 8.549 0z",
    transform: "translate(44.000000, 35.000000) translate(33.067966, 0.518818)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    d: "M3.073 35.111L6.433 20.976 39.009 17.116 43.504 35.71 43.851 18.019 21.426 2.821 2.89 17.168 3.073 35.111",
    transform: "translate(44.000000, 35.000000) translate(33.067966, 0.518818)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40AE29",
    d: "M23.464 0C33.7.005 43.906 10.517 43.852 17.915v11.421c-13.784-7.725-27.433-7.884-40.94 0v-11.42C2.967 10.501 13.23-.003 23.464 0z",
    transform: "translate(44.000000, 35.000000) translate(33.067966, 0.518818)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02751A",
    d: "M2.389 29.642c-.67-1.005-.4-2.361.605-3.03 3.76-2.509 9.927-4.12 18.5-4.834 1.18-.098 2.365-.1 3.545-.004 8.62.697 14.81 2.311 18.566 4.843 1.002.674 1.267 2.033.592 3.033-.673 1.002-2.032 1.268-3.033.592-3.3-2.223-8.752-3.6-16.356-4.132-1.027-.072-2.058-.07-3.084.005-7.564.55-13 1.929-16.305 4.133-.373.248-.794.368-1.212.368-.705 0-1.398-.342-1.818-.974z",
    transform: "translate(44.000000, 35.000000) translate(33.067966, 0.518818)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#586560",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.303.864c-17.16 0-33.165 11.41-38.08 27.744l-.092.329-.095.386-.098.445-.1.504-.158.866-.165.999c6.037-.345 9.06-.535 9.07-.571C13.255 18.781 25.927 9.79 39.303 9.79c13.031 0 25.472 8.533 29.44 20.858l9.253 1.891-.207-1.235-.198-1.107-.19-.978-.124-.581-.12-.525-.116-.47-.114-.412-.111-.358-.055-.158C71.265 11.344 55.746.864 39.303.864z",
    transform: "translate(44.000000, 35.000000) translate(14.441928, 92.136364) translate(2.274637, 0.000000)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F0C58A",
    d: "M4.787 5.274C7.737 1.312 11.8-1.046 15.03.457c1.356.632-.667 1.906-1.508 3.861-.16.374-.356.716-.577 1.021l3.14 1.475c1.93.91 2.796 3.18 1.965 5.145-1.375 3.253-2.947 6.397-4.742 9.412-1.416 2.378-4.243 3.525-6.933 2.873l-2.686-.652c-2.637-.64-4.24-3.33-3.516-5.945 1.032-3.733 2.278-7.393 3.74-10.98.195-.482.461-.914.78-1.289z",
    transform: "translate(44.000000, 35.000000) translate(14.441928, 92.136364) translate(0.000000, 10.163636)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.000000, 35.000000) translate(14.441928, 92.136364) translate(0.000000, 10.163636)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F0C58A",
    xlinkHref: "#gbetxoh7hd"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillOpacity: 0.08,
    xlinkHref: "#gbetxoh7hd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.000000, 35.000000) translate(14.441928, 92.136364) translate(0.000000, 10.163636)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F0C58A",
    xlinkHref: "#duo5y49k8e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillOpacity: 0.08,
    xlinkHref: "#duo5y49k8e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.000000, 35.000000) translate(14.441928, 92.136364) translate(0.000000, 10.163636)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F0C58A",
    xlinkHref: "#fpkmlx1z1f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillOpacity: 0.08,
    xlinkHref: "#fpkmlx1z1f"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F0C58A",
    d: "M13.83 5.298c.178.239.24.428.212.58.158.244.296.508.41.789 1.462 3.587 2.708 7.247 3.74 10.98.724 2.614-.88 5.305-3.515 5.945l-2.686.652c-2.69.652-5.518-.495-6.934-2.873-1.795-3.015-3.367-6.159-4.741-9.412C-.516 9.995.35 7.723 2.28 6.814l3.315-1.558c-.197-.284-.372-.598-.518-.938-.841-1.955-2.864-3.23-1.508-3.86 3.236-1.507 7.309.863 10.26 4.84z",
    transform: "translate(44.000000, 35.000000) translate(14.441928, 92.136364) translate(65.142620, 10.163636)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.000000, 35.000000) translate(14.441928, 92.136364) translate(65.142620, 10.163636)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F0C58A",
    xlinkHref: "#5opf1xrtzg"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillOpacity: 0.08,
    xlinkHref: "#5opf1xrtzg"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.000000, 35.000000) translate(14.441928, 92.136364) translate(65.142620, 10.163636)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F0C58A",
    xlinkHref: "#e3r20tdlmh"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillOpacity: 0.08,
    xlinkHref: "#e3r20tdlmh"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.000000, 35.000000) translate(14.441928, 92.136364) translate(65.142620, 10.163636)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F0C58A",
    xlinkHref: "#t0ea4jjvdi"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillOpacity: 0.08,
    xlinkHref: "#t0ea4jjvdi"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDB00",
    d: "M72.594 85.854h15.645c1.104 0 2-.895 2-2 0-.095-.007-.191-.02-.286l-.423-2.92c-.142-.983-.985-1.713-1.979-1.713H72.172c-1.105 0-2 .895-2 2 0 .096.007.191.02.286l.422 2.92c.142.983.986 1.713 1.98 1.713z",
    transform: "translate(44.000000, 35.000000)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.000000, 35.000000) translate(1.000000, 0.000000) translate(0.545509, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i2s6dxa8lk",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u58jf39lvj"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M54.788 0H111.121V128.917H54.788z",
    mask: "url(#i2s6dxa8lk)",
    opacity: 0.1
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDriverPreferencesFull);
export default __webpack_public_path__ + "static/media/icon-driver-preferences-full.2a3013f9f875aab5c7ba6c6ef9b5d978.svg";
export { ForwardRef as ReactComponent };